import { useOnType } from "use-ontype";

const OnTypeSearch = (onFinishState) => {
  return useOnType(
    {
      onTypeFinish: (val) => onFinishState(val),
    },
    1000
  );
};

export default OnTypeSearch;
